import { SignInForm } from "@/features/Auth/SignInForm";

export default function Login() {
  return (
    <div className="flex min-h-[calc(100dvh-56px)] items-center justify-center px-4 py-8 sm:min-h-[calc(100dvh-64px)] sm:py-4">
      <SignInForm />
    </div>
  );
}
